import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import SummarizeIcon from '@mui/icons-material/Summarize';

const AnalysisNavigation = ({ currentTab }) => {
  const { taskId } = useParams();
  const navigate = useNavigate();

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
    { id: 'investor_summary', label: 'Investor Summary', icon: <SummarizeIcon /> },
    { id: 'team', label: 'Team', icon: <GroupIcon /> },
    { id: 'product', label: 'Product', icon: <DescriptionIcon /> },
    { id: 'market', label: 'Market', icon: <BusinessIcon /> },
    { id: 'finance', label: 'Finance', icon: <MonetizationOnIcon /> },
    { id: 'strategic_finance', label: 'Finance Planning', icon: <StackedBarChartIcon /> }
  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Tabs 
        value={currentTab}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ 
          mb: 3,
          '& .MuiTabs-flexContainer': {
            justifyContent: 'center'
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 'medium',
            fontSize: '0.95rem',
            minWidth: 'auto',
            px: 3
          }
        }}
      >
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          value={tab.id}
          label={tab.label}
          icon={tab.icon}
          iconPosition="start"
          onClick={() => navigate(tab.id === 'dashboard' ? `/dashboard/${taskId}` : `/analysis/${taskId}/${tab.id}`)}
        />
      ))}
    </Tabs>
    </Box>
  );
};

export default AnalysisNavigation;
